import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import ProductRow from "./ProductRow";
import type { IExhibitorProduct } from "./products.type";

const statusOptions = [
	{
		id: "",
		name: "All",
	},
	{
		id: "approved",
		name: "Approved",
	},
	{
		id: "pending",
		name: "Pending",
	},
	{
		id: "rejected",
		name: "Rejected",
	},
];

const ProductPage = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});

	const [status, setStatus] = useState("");

	const { data: products, isLoading } = useGetQueryWithTotal<
		IExhibitorProduct[]
	>({
		endPoint: "/api/fair/products/for-admin",
		queryKeys: ["Products"],
		params: { pagination, status },
	});
	console.log({ products });
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<CommCard
			helmetTitle={"BTTF - Products List"}
			headerTitle={`Products List (${products?.total})`}
			showCardHeader
			showStatus
			statusOptions={statusOptions}
			handleSelectStatus={setStatus}
		>
			<>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Product</TableCell>
								<TableCell>Product URL</TableCell>
								<TableCell>Category</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Price</TableCell>
								<TableCell>Special Price</TableCell>
								<TableCell>Details</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : products?.data?.length > 0 ? (
							<TableBody>
								{products?.data?.map((product, index) => {
									return (
										<ProductRow
											key={product.fair_member_product_id}
											product={product}
											serial={index + 1}
											paginationSkip={pagination.skip}
										/>
									);
								})}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={products?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
				{/* 
				<ModalsWrapper
					showModal={open}
					setShowModal={setOpen}
					modalData={{ title: "Create Money Receipt" }}
				>
					<CreateMoneyReceipt handleClose={handleClose} />
				</ModalsWrapper> */}
			</>
		</CommCard>
	);
};

export default ProductPage;
